'use client'

import type React from 'react'
import { use } from 'react'
import { useModals, useSearchParams } from '@/lib/hooks'
import { useAppSelector } from '@/lib/hooks/use-redux'

import { Dialog, DialogContent } from '@/components/ui'
import { AddCartDiscount } from '@/components/forms/add-cart-discount'
import { RefContext, type Refs } from '@/components/providers/ref-provider'

interface AddCartDiscountModalProps
  extends React.ComponentPropsWithoutRef<'div'> {
  open?: boolean
}

export const AddCartDiscountModal = ({ open }: AddCartDiscountModalProps) => {
  const { closeModal } = useModals()
  const { cartId } = useSearchParams()
  const { barcodeInputRef } = use(RefContext) as Refs

  return (
    <Dialog open={open} onOpenChange={() => barcodeInputRef.current?.focus()}>
      <DialogContent
        closeOnOverlay
        onClose={() => closeModal('ADD_CART_DISCOUNT')}
        size="md"
        className="min-h-[200px]"
      >
        {cartId && <AddCartDiscount cartId={cartId} />}
      </DialogContent>
    </Dialog>
  )
}
